exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ndv_modal_tabs a {\n  width: 500px;\n}\n", ""]);

// exports
